import React from 'react';
import { useStoreConfigContext } from '/src/providers';
import { Form } from '/src/components';
import * as styles from './styles.scss';

const WishListForm = ({
    data,
    handleChange,
    handleSubmit,
    isLoadingWishLists,
    children
}) => {
    const {
        translate
    } = useStoreConfigContext();

    return (
        <div className={styles.section}>
            <form
                className={styles.form}
                onSubmit={handleSubmit}
            >
                <input
                    className={styles.new}
                    type="text"
                    name="name"
                    value={data.name}
                    onChange={handleChange}
                    autoComplete="off"
                />
                <Form.Checkbox
                    key="visibility"
                    label={translate('Private')}
                    type="checkbox"
                    name="visibility"
                    checked={data.visibility}
                    onChange={handleChange}
                />
                <button
                    className={`${styles.button} ${styles.save}`}
                    aria-label="Edit Wishlist" title="Edit"
                    disabled={isLoadingWishLists}
                >
                    <span>{translate('Save')}</span>
                </button>
            </form>
            {children}
        </div>
    );
}

export default WishListForm;
